import useSWR from "swr";
import axios from "axios";

function useSupportTickets({ userId, status, priority, startDate, endDate, page, perPage, sortField, sortOrder }) {
  return useSWR([
    `${process.env.REACT_APP_API_URL}/support-tickets`, userId, status, priority, startDate, endDate, page, perPage, sortField, sortOrder
  ], async ([url, userId, status, priority, startDate, endDate, page, perPage, sortField, sortOrder]) => {
    const params = new URLSearchParams();

    if (userId) params.append('user', userId);
    if (status) params.append('status', status);
    if (priority) params.append('priority', priority);
    if (page) params.append('page', page);
    if (perPage) params.append('perPage', perPage);
    if (sortField) params.append('sortField', sortField);
    if (sortOrder) params.append('sortOrder', sortOrder);
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);

    const { data: { supportTickets, count } } = await axios.get(`${url}?${params.toString()}`);

    return { supportTickets, count };
  });
}

export default useSupportTickets;
